// Don't update API without discussion
app.swymApi = (function () {
  let listId;
  let listConfig = {
    "lname": "black friday list",
  };
  let _listContents;
  let _fetchListContentPromise;

  let createList = function() {
    return new Promise((resolve, reject) => {
      let onSuccess = (newList) => { 
        listId = newList.lid;
        resolve();
      }

      let onError = function(error) {
        console.log("Error while creating a List", error);
        reject();
      }

      const onSwymLoadCallback = (swat) => {
        swat.createList(listConfig, onSuccess, onError);
      }

      window.SwymCallbacks.push(onSwymLoadCallback);
    })
  }

  let fetchListContent = async function () {
    if(!listId) await createList();
    return new Promise((resolve, reject) => {
      let onSuccess = function (listContents){
        resolve(listContents);
      }

      let onError = function (error){
        reject(error);
      }

      const onSwymFetchCallback = (swat) => {
        swat.fetchListCtx(listId, onSuccess, onError);
      }
      window.SwymCallbacks.push(onSwymFetchCallback);
    });
  }

  let _addToList = async function (product) {
    return new Promise((resolve, reject) => {
      let onSuccess = function (addedListItem){
        resolve(addedListItem);
      }

      let onError = function (error){
        console.log("Error while adding the Product to the List", error);
        reject(error);
      }

      const onSwymAddToListCallback = (swat) => {
        swat.addToList(listId, product, onSuccess, onError);
      }
      window.SwymCallbacks.push(onSwymAddToListCallback);
    });
  }

  let addToList = async function(product) {
    let addedListItem = await _addToList(product);
    let listContents = await fetchListContent();
    _listContents = listContents;
    return addedListItem;
  }

  let _deleteFromList = async function(product) {
    return new Promise((resolve, reject) => {
      let onSuccess = function (deletedProduct){
        resolve(deletedProduct);
      }
  
      let onError = function (error){
        console.log("Error while deleting the Product", error);
        reject(error);
      }
  
      const onSwymDeleteFromWislistCallback = (swat) => {
        swat.deleteFromList(listId, product, onSuccess, onError);
      }
      window.SwymCallbacks.push(onSwymDeleteFromWislistCallback);
    });
  }

  let deleteFromList = async function(product) {
    let deletedProduct = await _deleteFromList(product);
    _listContents = await fetchListContent();
    return deletedProduct;
  }

  let getListContents = function() {
    if(_listContents) {
      return _listContents;
    }
   
    if(!_fetchListContentPromise) {
      _fetchListContentPromise = fetchListContent();
    }

    return _fetchListContentPromise;
  }

  if(!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  return {
    addToList,
    deleteFromList,
    getListContents,
  }
})();
